module.exports = __webpack_public_path__ + "static/media/bn_1.4808e399.png";